import React from "react";
var REQUIRED_FIELD_SYMBOL = "*";
function TitleField(props) {
  var id = props.id,
    title = props.title,
    required = props.required;
  return React.createElement("legend", {
    id: id
  }, title, required && React.createElement("span", {
    className: "required"
  }, REQUIRED_FIELD_SYMBOL));
}
if (process.env.NODE_ENV !== "production") {}
export default TitleField;